import { useMemo, useState } from 'react';
import { CreateRelationDialog } from './CreateRelationDialog';

type DialogState = {
  rootAnnotationUrl: string;
  lockedSubtypeName?: string;
  defaultQueueUrl?: string;
};

export const useCreateRelationDialog = ({
  onClose,
}: {
  onClose?: () => void;
} = {}) => {
  const [dialogState, setDialogState] = useState<DialogState | null>(null);

  const openDialog = (
    url: string,
    options: { lockedSubtypeName?: string; defaultQueueUrl?: string } = {}
  ) => setDialogState({ rootAnnotationUrl: url, ...options });

  const node = useMemo(
    () => (
      <CreateRelationDialog
        // Remount the dialog on every open so its internal state starts fresh.
        key={`${dialogState?.rootAnnotationUrl}-${dialogState?.lockedSubtypeName}`}
        onClose={() => {
          setDialogState(null);
          onClose?.();
        }}
        rootAnnotationUrl={dialogState?.rootAnnotationUrl ?? null}
        lockedSubtypeName={dialogState?.lockedSubtypeName ?? null}
        defaultQueueUrl={dialogState?.defaultQueueUrl ?? null}
      />
    ),
    [onClose, dialogState]
  );

  return { node, openDialog };
};
